import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationAutomaticAssignmentAlgorithmStepCreateRequest,
    ConfigurationAutomaticAssignmentAlgorithmStepPatchRequest,
    ConfigurationAutomaticAssignmentAlgorithmStepResponse
} from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm-step/configuration-automatic-assignment-algorithm-step.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationAutomaticAssignmentAlgorithmStepService {
    async create(laboratoryId: number, request: ConfigurationAutomaticAssignmentAlgorithmStepCreateRequest): Promise<ConfigurationAutomaticAssignmentAlgorithmStepResponse> {
        const response = await axios.post<ConfigurationAutomaticAssignmentAlgorithmStepResponse>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithmsSteps`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticAssignmentAlgorithmStepResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticAssignmentAlgorithmStepResponse>>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithmsSteps`, { ...filterModel }, { params })
        return response.data
    }

    async delete(automaticAssignmentAlgorithmStepId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithmsSteps/${automaticAssignmentAlgorithmStepId}`)
        return response.data
    }

    async patch(automaticAssignmentAlgorithmStepId: number, laboratoryId: number, request: ConfigurationAutomaticAssignmentAlgorithmStepPatchRequest): Promise<void> {
        const response = await axios.patch<void>(`/configuration/laboratories/${laboratoryId}/automaticAssignmentAlgorithmsSteps/${automaticAssignmentAlgorithmStepId}`, request)
        return response.data
    }
}

export const configurationAutomaticAssignmentAlgorithmStepService = new ConfigurationAutomaticAssignmentAlgorithmStepService()
